export default "__VITE_ASSET__Bd6_AIqf__"